import type { QueueEntry } from "../../shared/global-queue";

const ineligibleReasons: Record<string, string> = {
  author: "Authored by you",
  "approvals-satisfied": "No more reviews needed",
  "chew-review-current": "Your review is complete",
  "github-review-current": "Your review is complete",
  "routed-elsewhere": "Routed elsewhere",
  "claimed-by-another": "Claimed by someone else",
  "active-reviewer": "No action for you",
  "source-refreshing": "Syncing",
};

/** Why a tracked pull request is not actionable by the viewer, for the empty-queue breakdown. */
export function queueViewerStatus(entry: QueueEntry): string {
  if (entry.forMe.skipped) return "Passed by you";
  return ineligibleReasons[entry.forMe.reasonCode] ?? "Unavailable to you";
}

/** How deep the shared queue is: PRs reviewable now that GitHub routes to nobody in particular. */
export function generalQueueDepth(entries: QueueEntry[]): number {
  return entries.filter((entry) => entry.status === "ready" && entry.routing === "pool").length;
}
